module.exports = __webpack_public_path__ + "static/img/1.482ff8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/yijia/1.png
// module id = pnkC
// module chunks = 0